import React from "react";
import { Layout, Menu, message } from "antd";
import {
  ProjectOutlined,
  TeamOutlined,
  SettingOutlined,
  MessageOutlined,
  LogoutOutlined,
  BulbOutlined,
  FormOutlined,
  EditOutlined,
  UserAddOutlined,
  EuroCircleOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import { useNavigate ,useLocation  } from "react-router-dom";
import "./sidebar.css";
import logo from "./logost.png";

const { Sider } = Layout;

const Sidebar = ({ collapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();

  //Logout Function
  const handleMenuClick = (e) => {
    if (e.key === "/logout") {
      // remove JWT
      localStorage.removeItem("token");
      message.success("Logout successfully");
      // login page
      navigate("/"); 
      return;
    }

    navigate(e.key);
  };

  return (
    <Sider
      className="admin-sidebar"
      collapsible
      collapsed={collapsed}
      trigger={null}
      width={250}
      collapsedWidth={80}
    >
      {/* Logo */}
      <div className="logo-container">
        <img src={logo} alt="Logo" className="logo-img" />
        {!collapsed && <span className="brand-text">Steel City</span>}
      </div>

      {/* Menu */}
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]} // ✅ FIX
        defaultSelectedKeys={["/admin"]}
        onClick={handleMenuClick}
        items={[
          { key: "/admin", icon: <ProjectOutlined />, label: "Recent Works" },
          { key: "/admin-teams", icon: <TeamOutlined />, label: "Teams" },
          { key: "/admin-machineries", icon: <SettingOutlined />, label: "Machineries" },
          { key: "/admin-feedback", icon: <MessageOutlined />, label: "Feedbacks" },
          { key: "/admin-service", icon: <BulbOutlined />, label: "Service" },
          { key: "/admin-main-setting", icon: <FormOutlined />, label: "Main Title Setting" },
          { key: "/admin-marquee-setting", icon: <EditOutlined />, label: "Marquee Setting" },
          { key: "/admin-happy-client", icon: <UserAddOutlined />, label: "Happy Client" },
          { key: "/admin-feedback-setting", icon: <EuroCircleOutlined />, label: "Feedback Setting" },
          { key: "/admin-pdf-upload", icon: <FilePdfOutlined />, label: "PDF Upload" },
          
          {
            key: "/logout",
            icon: <LogoutOutlined />,
            label: "Logout",
            className: "logout-menu",
          },
        ]}
      />
    </Sider>
  );
};

export default Sidebar;
